<template>
    <div class="jump-usercenter nav-bar-fixed">
        <van-nav-bar title="个人发票" left-arrow fixed  @click-left="back" />
        
             <van-field
              label="发票抬头"
              placeholder="请输入正确信用代码"
            />
             <van-field
              label="邮箱账号"
              placeholder="请输入正确的邮箱号"
            />
             <van-field
              label="电子邮箱"
              placeholder="请输入正确邮箱格式"
            />
         <div class="usercenter-button">
              <van-button  size="large">提 交</van-button>
         </div>
    </div>
</template>
<script>
import {
  NavBar,
  Row,
  Col,
  Field,
  Button
} from "vant";

export default {
  name: "OrderInvoiceSelf",
  components: {
    [NavBar.name]: NavBar,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [Button.name]: Button
  },
  data() {
    return {
    };
  },
  methods: {
      back(){
          history.back();
      }
  }
};
</script>
<style lang="less">
@bule-thame: #3c6eeb;
.jump-usercenter {
  padding-top: 50px;
  h5{
    color: @bule-thame;
    font-size: 16px;
    padding: 10px 15px;
  }
  button {
    background-color: @bule-thame;
    border-color: @bule-thame;
  }
  .usercenter-button {
    padding: 0 15px;
    button {
      background-color: @bule-thame;
      color: white;
      font-weight: 700;
      border-radius: 5px;
      margin: 25px 0 10px;
    }
  }

}
</style>

